<template>
	<div class="pui-form">
		<mtipotransporte-modals :modelName="modelName"></mtipotransporte-modals>
		<!--<pui-form-header
			v-if="modelLoaded"
			:showHeader="!isCreatingElement">
			<mtipotransporte-form-header
				:modelPk="modelPk"
			></mtipotransporte-form-header>
		</pui-form-header>-->
		<v-form class="mb-4 pb-4" ref="form" v-model="valid" lazy-validation @submit.prevent v-if="modelLoaded">
			<v-layout wrap class="pui-form-layout">
				<v-flex xs12 md12>
					<pui-field-set :title="getTitleDatos">
						<v-layout wrap>
							<!-- IDTIPTRANS -->
							<v-flex xs12 md1>
								<pui-text-field
									:id="`idtiptrans-mtipotransporte`"
									v-model="model.idtiptrans"
									:label="$t('mtipotransporte.idtiptrans')"
									disabled
									toplabel
									maxlength="10"
								></pui-text-field>
							</v-flex>
							<!-- CODTIPTRANSEDI -->
							<v-flex xs12 md1>
								<pui-text-field
									:id="`codtiptransedi-mtipotransporte`"
									v-model="model.codtiptransedi"
									:label="$t('mtipotransporte.codtiptransedi')"
									:disabled="formDisabled"
									required
									toplabel
									maxlength="3"
								></pui-text-field>
							</v-flex>
						</v-layout>
						<v-layout wrap>
							<!-- NAME -->
							<v-flex xs12 md4>
								<pui-text-field
									:id="`name-mtipotransporte`"
									v-model="model.name"
									:label="$t('mtipotransporte.name')"
									:disabled="formDisabled"
									required
									toplabel
									maxlength="50"
								></pui-text-field>
							</v-flex>
						</v-layout>
						<v-layout wrap>
							<!-- FECBAJA -->
							<v-flex xs12 md3>
								<pui-date-field
									:id="`fecbaja-mtipotransporte`"
									v-model="model.fecbaja"
									:label="$t('mtipotransporte.fecbaja')"
									:disabled="formDisabled"
									toplabel
									time
								></pui-date-field>
							</v-flex>
						</v-layout>
						<!-- MINI AUDIT -->
						<pui-form-mini-audit class="pl-2" :model="model" v-if="!isCreatingElement"></pui-form-mini-audit>
					</pui-field-set>
				</v-flex>
			</v-layout>

			<!-- Page Footer -->
			<pui-form-footer v-if="!isModalDialog">
				<pui-form-footer-btns
					:formDisabled="formDisabled"
					:saveDisabled="saving"
					:saveAndNew="saveAndNew"
					:saveAndUpdate="saveAndUpdate"
					:save="save"
					:back="back"
				></pui-form-footer-btns>
			</pui-form-footer>
		</v-form>
		<pui-form-loading v-else></pui-form-loading>
	</div>
</template>

<script>
import {PuiFormMethodsMixin} from '@Pui9Components';
import mtipotransporteActions from './MtipotransporteActions';
import mtipotransporteModals from './MtipotransporteModals.vue';

export default {
	name: 'mtipotransporte-form',
	mixins: [PuiFormMethodsMixin],
	components: {
		'mtipotransporte-modals': mtipotransporteModals
	},
	data() {
		return {
			modelName: 'mtipotransporte',
			actions: mtipotransporteActions.formActions
		};
	},
	methods: {
		afterGetData() {
			// Do something after get data from server
		}
	},
	computed: {
		getTitleDatos() {
			return this.$t('form.mtipotransporte');
		}
	},
	created() {}
};
</script>
